import React from 'react';
import Footer from '../components/Footer';
import CSHealthnessIntro from '../components/CSHealthIntro';
import Contact from './Contact';

const CaseStudyHealthness = () => {
    return (
        <>
            <CSHealthnessIntro />
            <Contact />
        </>

    )
}

export default CaseStudyHealthness;
